import React, { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";

import { Divider, TextField, Typography } from "@mui/material";

export default function Texts({ client, handleReplaceFormData, FORM_MODE }) {
  const [formData, setFormData] = useState(client);

  useEffect(() => {
    if (client) {
      setFormData(client);
    }
  }, [client]);

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const handleBlur = () => {
    handleReplaceFormData(formData);
  };

  return (
    <Grid container item>
      <Typography sx={{ marginBottom: "0.5rem" }}>Faktura</Typography>
      <Grid item container xs={12} sm={12} md={12} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Faktura_FooterText"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Fakturatext SE"
            value={formData.Faktura_FooterText}
            onChange={(e) =>
              handleInputChange("Faktura_FooterText", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Faktura_TransferText"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Överlåtelsetext SE"
            value={formData.Faktura_TransferText}
            onChange={(e) =>
              handleInputChange("Faktura_TransferText", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
            onBlur={handleBlur}
          />
        </Grid>
      </Grid>
      <Typography sx={{ marginTop: "1rem", marginBottom: "0.5rem" }}>
        Kredit
      </Typography>
      <Grid item container xs={12} sm={12} md={12} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Kredit_FooterText"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Fakturatext SE"
            value={formData.Kredit_FooterText}
            onChange={(e) =>
              handleInputChange("Kredit_FooterText", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Kredit_TransferText"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Överlåtelsetext SE"
            value={formData.Kredit_TransferText}
            onChange={(e) =>
              handleInputChange("Kredit_TransferText", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
            onBlur={handleBlur}
          />
        </Grid>
      </Grid>
      <Typography sx={{ marginTop: "1rem", marginBottom: "0.5rem" }}>
        Påminnelse
      </Typography>
      <Grid item container xs={12} sm={12} md={12} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Påminnelse_AlertText"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Varningstext SE"
            value={formData.Påminnelse_AlertText}
            onChange={(e) =>
              handleInputChange("Påminnelse_AlertText", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
            onBlur={handleBlur}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Påminnelse_FooterText"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Sidfotstext SE"
            value={formData.Påminnelse_FooterText}
            onChange={(e) =>
              handleInputChange("Påminnelse_FooterText", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Påminnelse_ReminderText"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Påminnelsetext SE"
            value={formData.Påminnelse_ReminderText}
            onChange={(e) =>
              handleInputChange("Påminnelse_ReminderText", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
            onBlur={handleBlur}
          />
        </Grid>
      </Grid>
      <Typography sx={{ marginTop: "1rem", marginBottom: "0.5rem" }}>
        Räntefaktura
      </Typography>
      <Grid item container xs={12} sm={12} md={12} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Räntefaktura_AlertText"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Varningstext SE"
            value={formData.Räntefaktura_AlertText}
            onChange={(e) =>
              handleInputChange("Räntefaktura_AlertText", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Räntefaktura_FooterText"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Sidfotstext SE"
            value={formData.Räntefaktura_FooterText}
            onChange={(e) =>
              handleInputChange("Räntefaktura_FooterText", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
            onBlur={handleBlur}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
